import { FC } from 'react';
import { Radio as AntdRadio, RadioProps as AntdRadioProps } from 'antd';
import styled from 'styled-components';

import { COLORS } from '../../constants/colors';

type RadioProps = AntdRadioProps;

export const Radio: FC<RadioProps> = ({ ...props }) => {
  return <Container {...props} />;
};

const Container = styled(AntdRadio)`
  &.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
    border-color: ${COLORS.systemSky200};
    background-color: ${COLORS.systemSky200};
  }
`;
